import { addOpenDrawer } from "store/actions/appAction";
import { PriceComponent, StatusComponent } from "components/Table/CellComponents";
import { ChequeChangeStatus } from "components/Table/FooterComponent";
import { Dispatch } from "redux";
import { apiDeleteCheques, apiGetCheques } from "../api/chequeApi";

const receiveTableColumns = [
    {
        name: "شماره",
        key: "number",
        filterParams: {
            column: "number",
            columnType: "string",
        },
    },
    {
        name: "کد حسابداری تراکنش ",
        key: "accountingCode",
        filterParams: {
            column: "number",
            columnType: "string",
        },
    },
    {
        name: "شماره صیاد",
        key: "sayad",
        filterParams: {
            column: "sayad",
            columnType: "string",
        },
    },
    {
        name: "سررسید",
        key: "dueDate",
        filterParams: {
            column: "dueDate",
            columnType: "date",
        },
        searchType: "date",
    },
    {
        name: "مبلغ",
        key: "amount",
        price: true,
        Component: PriceComponent,
        filterParams: {
            column: "amount",
            columnType: "number",
        },
        searchType: "quantitative",
    },
    {
        name: "پرداخت کننده",
        key: "nickName",
        filterParams: {
            column: "payment_id",
            columnType: "string",
            relationModelName: "Person",
            relationColumn: "nickName",
            staticColumn: "payment_type",
            staticValue: "person",
        },
        getValue: (item: { payer: any }) => item.payer,
    },

    {
        name: "بانک",
        key: "bank",
        filterParams: {
            column: "bank",
            columnType: "string",
        },
    },
    {
        name: "شعبه",
        key: "branch",
        filterParams: {
            column: "branch",
            columnType: "string",
        },
    },
    {
        name: "وضعیت",
        key: "status",
        Component: StatusComponent,
    },
];

const paymentTableColumns = [
    {
        name: "شماره",
        key: "number",
        filterParams: {
            column: "number",
            columnType: "string",
        },
    },
    {
        name: "کد حسابداری تراکنش",
        key: "accountingCode",
        filterParams: {
            column: "number",
            columnType: "string",
        },
    },
    {
        name: "شماره صیاد",
        key: "sayad",
        filterParams: {
            column: "sayad",
            columnType: "string",
        },
    },
    {
        name: "سررسید",
        key: "dueDate",
        filterParams: {
            column: "dueDate",
            columnType: "date",
        },
        searchType: "date",
    },
    {
        name: "مبلغ",
        key: "amount",
        price: true,
        Component: PriceComponent,
        filterParams: {
            column: "amount",
            columnType: "number",
        },
        searchType: "quantitative",
    },
    {
        name: "دریافت کننده",
        key: "payTo",
        filterParams: {
            column: "receive_id",
            columnType: "string",
            relationModelName: "Person",
            relationColumn: "nickName",
            staticColumn: "receive_type",
            staticValue: "financial",
        },
    },
    {
        name: "پرداخت کننده",
        key: "nickName",
        filterParams: {
            column: "payment_id",
            columnType: "string",
            relationModelName: "Financial",
            relationColumn: "name",
            staticColumn: "payment_type",
            staticValue: "financial",
        },
        getValue: (item: { paymented: any }) => item?.paymented?.name,
    },
    {
        name: "کد حسابداری",
        key: "accountingCode",
        filterParams: {
            column: "payment_id",
            columnType: "string",
            relationModelName: "Financial",
            relationColumn: "accountingCode",
            staticColumn: "payment_type",
            staticValue: "financial",
        },
        getValue: (item: { paymented: any }) => item?.paymented?.accountingCode,
    },
    {
        name: "بانک",
        key: "bank",
        filterParams: {
            column: "bank",
            columnType: "string",
        },
    },
    {
        name: "شعبه",
        key: "branch",
        filterParams: {
            column: "branch",
            columnType: "string",
        },
    },
    {
        name: "وضعیت",
        key: "status",
        Component: StatusComponent,
    },
];

const ReceivedFooter = ({ selectedItem }: { selectedItem: number | string }) => {
    return <ChequeChangeStatus type="received" selectedItem={selectedItem} />;
};
const PaidFooter = ({ selectedItem }: { selectedItem: number | string }) => {
    return <ChequeChangeStatus type="paid" selectedItem={selectedItem} />;
};

const openDrawer = (dispatch: Dispatch, cheque: any) => {
    if (cheque.type === "receive") {
        if (cheque.status === "عادی") {
            cheque.actions = ["receipt", "deposit", "refund"];
        } else if (cheque.status === "در جریان وصول") {
            cheque.actions = ["normal", "depositReceipt"];
        } else if (cheque.status === "وصول شده") {
            cheque.actions = ["normal"];
        } else if (cheque.status.trim() === "عودت") {
            cheque.actions = ["normal"];
        } else if (cheque.status === "خرج شده") {
            cheque.actions = ["spent"];
        }
    } else {
        if (cheque.status === "عادی") {
            cheque.actions = ["receipt", "refund"];
        } else if (cheque.status === "پاس شده") {
            cheque.actions = ["normal"];
        } else if (cheque.status.trim() === "عودت") {
            cheque.actions = ["normal"];
        }
    }
    dispatch(addOpenDrawer(true, "chequeDrawer", "left", { cheque }));
};

export const chequeIndexData = {
    receivedCheques: [
        {
            title: "همه",
            pluralLabel: "لیست چک های دریافتی",
            description: "",
            key: "receivedChequesAll",
            type: "receive",
            isCheque: true,
            label: "لیست چک های دریافتی",
            pageTitle: "لیست چک های دریافتی",
            pageDescription: "نمایش چک های دریافتی کسب و کار",
            notEditable: true,
            tableColumns: receiveTableColumns,
            disableDateFilter: true,
            // FooterComponent: ReceivedFooter,
            actions: {
                back: {},
                fetch: apiGetCheques,
                delete: apiDeleteCheques,
                openDrawer: openDrawer,
            },
        },
        {
            title: "عادی",
            description: "",
            key: "receivedChequesNormal",
            type: "receive",
            isCheque: true,
            label: "لیست چک های دریافتی",
            pageTitle: "لیست چک های دریافتی",
            pageDescription: "نمایش چک های با وضعیت عادی کسب و کار",
            pluralLabel: "لیست چک های دریافتی",
            notEditable: true,
            tableColumns: receiveTableColumns,
            disableDateFilter: true,
            // FooterComponent: ReceivedFooter,
            actions: {
                fetch: apiGetCheques,
                delete: apiDeleteCheques,
                openDrawer: openDrawer,
            },
        },
        {
            title: "سررسید گذشته",
            description: "",
            key: "receivedChequesExpired",
            type: "receive",
            isCheque: true,
            label: "لیست چک های دریافتی",
            pageTitle: "لیست چک های دریافتی",
            pageDescription: "نمایش چک های سررسید گذشته کسب و کار",
            pluralLabel: "لیست چک های دریافتی",
            notEditable: true,
            tableColumns: receiveTableColumns,
            disableDateFilter: true,
            // FooterComponent: ReceivedFooter,
            actions: {
                fetch: apiGetCheques,
                delete: apiDeleteCheques,
                openDrawer: openDrawer,
            },
        },
        {
            title: "در جریان وصول",
            description: "",
            key: "receivedChequesDeposit",
            type: "receive",
            isCheque: true,
            label: "لیست چک های دریافتی",
            pageTitle: "لیست چک های دریافتی",
            pageDescription: "نمایش چک های در جریان وصول کسب و کار",
            pluralLabel: "لیست چک های دریافتی",
            notEditable: true,
            tableColumns: receiveTableColumns,
            disableDateFilter: true,
            // FooterComponent: ReceivedFooter,
            actions: {
                fetch: apiGetCheques,
                delete: apiDeleteCheques,
                openDrawer: openDrawer,
            },
        },
        {
            title: "وصول شده",
            description: "",
            key: "receivedChequesReceiveReceipt",
            type: "receive",
            isCheque: true,
            label: "لیست چک های دریافتی",
            pageTitle: "لیست چک های دریافتی",
            pageDescription: "نمایش چک های وصول شده کسب و کار",
            pluralLabel: "لیست چک های دریافتی",
            notEditable: true,
            tableColumns: receiveTableColumns,
            disableDateFilter: true,
            // FooterComponent: ReceivedFooter,
            actions: {
                fetch: apiGetCheques,
                delete: apiDeleteCheques,
                openDrawer: openDrawer,
            },
        },
        {
            title: "عودت شده",
            description: "",
            key: "receivedChequesReceiveRefund",
            type: "receive",
            isCheque: true,
            label: "لیست چک های دریافتی",
            pageTitle: "لیست چک های دریافتی",
            pageDescription: "نمایش چک های عودت شده کسب و کار",
            pluralLabel: "لیست چک های دریافتی",
            notEditable: true,
            tableColumns: receiveTableColumns,
            disableDateFilter: true,
            // FooterComponent: ReceivedFooter,
            actions: {
                fetch: apiGetCheques,
                delete: apiDeleteCheques,
                openDrawer: openDrawer,
            },
        },
        {
            title: "خرج شده",
            description: "",
            key: "receivedChequesSpent",
            type: "receive",
            isCheque: true,
            label: "لیست چک های دریافتی",
            pageTitle: "لیست چک های دریافتی",
            pageDescription: "نمایش چک های خرج شده کسب و کار",
            pluralLabel: "لیست چک های دریافتی",
            notEditable: true,
            tableColumns: [...receiveTableColumns.slice(0, 5), {
                name: "دریافت کننده",
                key: "receivedNickName",
                filterParams: {
                    column: "receive_id",
                    columnType: "string",
                    relationModelName: "Person",
                    relationColumn: "nickName",
                    staticColumn: "receive_type",
                    staticValue: "person",
                },
                getValue: (item: any) => item.receivedNickName,
            }, ...receiveTableColumns.slice(6, receiveTableColumns.length - 1)],
            disableDateFilter: true,
            // FooterComponent: ReceivedFooter,
            actions: {
                fetch: apiGetCheques,
                delete: apiDeleteCheques,
                openDrawer: openDrawer,
            },
        },
    ],
    paymentCheques: [
        {
            title: "همه",
            description: "",
            type: "payment",
            isCheque: true,
            key: "paymentChequesAll",
            label: "لیست چک های پرداختی",
            pageTitle: "لیست چک های پرداختی",
            pluralLabel: "لیست چک های پرداختی",
            notEditable: true,
            tableColumns: paymentTableColumns,
            disableDateFilter: true,
            // FooterComponent: PaidFooter,
            actions: {
                fetch: apiGetCheques,
                delete: apiDeleteCheques,
                openDrawer: openDrawer,
            },
        },
        {
            title: "عادی",
            description: "",
            type: "payment",
            isCheque: true,
            key: "paymentChequesNormal",
            label: "لیست چک های پرداختی",
            pageTitle: "لیست چک های پرداختی",
            pageDescription: "نمایش چک های وضعیت عادی کسب و کار",
            pluralLabel: "لیست چک های پرداختی",
            notEditable: true,
            tableColumns: paymentTableColumns,
            disableDateFilter: true,
            // FooterComponent: PaidFooter,
            actions: {
                fetch: apiGetCheques,
                delete: apiDeleteCheques,
                openDrawer: openDrawer,
            },
        },
        {
            title: "سررسید گذشته",
            description: "",
            type: "payment",
            isCheque: true,
            key: "paymentChequesExpired",
            label: "لیست چک های پرداختی",
            pageTitle: "لیست چک های پرداختی",
            pageDescription: "نمایش چک های سررسید گذشته کسب و کار",
            pluralLabel: "لیست چک های پرداختی",
            notEditable: true,
            tableColumns: paymentTableColumns,
            disableDateFilter: true,
            // FooterComponent: PaidFooter,
            actions: {
                fetch: apiGetCheques,
                delete: apiDeleteCheques,
                openDrawer: openDrawer,
            },
        },
        {
            title: "پاس شده",
            description: "",
            type: "payment",
            isCheque: true,
            key: "paymentChequesPaidReceipt",
            label: "لیست چک های پرداختی",
            pageTitle: "لیست چک های پرداختی",
            pageDescription: "نمایش چک های پاس شده کسب و کار",
            pluralLabel: "لیست چک های پرداختی",
            notEditable: true,
            tableColumns: paymentTableColumns,
            disableDateFilter: true,
            // FooterComponent: PaidFooter,
            actions: {
                fetch: apiGetCheques,
                delete: apiDeleteCheques,
                openDrawer: openDrawer,
            },
        },
        {
            title: "عودت شده",
            description: "",
            key: "paymentChequesPaidRefund",
            type: "payment",
            isCheque: true,
            label: "لیست چک های پرداختی",
            pageTitle: "لیست چک های پرداختی",
            pageDescription: "نمایش چک های عودت شده کسب و کار",
            pluralLabel: "لیست چک های پرداختی",
            notEditable: true,
            tableColumns: paymentTableColumns,
            disableDateFilter: true,
            // FooterComponent: ReceivedFooter,
            actions: {
                fetch: apiGetCheques,
                delete: apiDeleteCheques,
                openDrawer: openDrawer,
            },
        },
    ],
};
